import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { env } from '../../environments/environment';

@Injectable()
export class BackendProvider {

  private requestId = 0;

  constructor(private http: HttpClient) {}
  
  public async get(endpoint: string, params?: {key: string, value: string}[]): Promise<any> {
    const timer = this.timer.init();

    const queryString = params
      ? '?' + params.map(item => `${item.key}=${item.value}`).join('&')
      : '';
      
    const reqId = ++this.requestId;
    let response, error;

    try {
      console.log(`API call #${reqId}:`, `GET ${endpoint}`);
      response = await this.http.get<any>(`${env.API_URL}${endpoint}${queryString}`).toPromise();
      console.log(`API call #${reqId} OK:`, response);
    }
    catch(err) {
      console.error(`API call #${reqId} FAILED:`, err);
      error = err;
    }

    return new Promise((resolve, reject) => setTimeout(() => {
      response ? resolve(response) : reject(error);
    }, timer.end()));   
  }

  public async post(endpoint: string, body: {[key: string]: string | any[]}): Promise<any> {
    const timer = this.timer.init();

    const reqId = ++this.requestId;
    let response, error;

    try {
      console.log(`API call #${reqId}:`, `POST ${endpoint}`);
      response = await this.http.post<any>(`${env.API_URL}${endpoint}`, body).toPromise();
      console.log(`API call #${reqId} OK:`, response);
    }
    catch(err) {
      console.error(`API call #${reqId} FAILED:`, err);
      error = err;
    }

    return new Promise((resolve, reject) => setTimeout(() => {
      response ? resolve(response) : reject(error);
    }, timer.end()));   
  }

  private timer = (() => {
    const MIN_WAIT_TIME = 1000; // ms

    const init = () => {
      const startTime = Date.now();
      return {
        end: () => schedule(startTime)
      };
    };

    const schedule = (startTime: number) => {
      const elapsed = Date.now() - startTime;
      return (elapsed < MIN_WAIT_TIME) ? MIN_WAIT_TIME - elapsed : 0;
    };

    return {
      init
    };
    
  })();

}
